/* global gdAlertify */
import React, { useState } from 'react';
import Logo from '../assets/images/sk-logo.png';
import axiosInstance, { setAuthToken } from '../config/axiosConfig';
import { useNavigate } from 'react-router-dom';

function Login({ setIsAuthenticated }) {
    const navigate = useNavigate();
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [showPassword, setShowPassword] = useState(false); // 👈 estado para mostrar/ocultar

    const handleLogin = (e) => {
        e.preventDefault();
        setIsLoading(true);

        const data = new URLSearchParams();
        data.append("email", username);
        data.append("password", password);

        axiosInstance.post("/login", data)
            .then((response) => {
                setIsLoading(false);
                const result = response.data;

                if (result.error) {
                    gdAlertify.notiError(result.message);
                    return false;
                }

                localStorage.setItem('isAuthenticated', 'true');
                localStorage.setItem('authToken', result.token);
                setAuthToken(result.token);

                setIsAuthenticated(true);
                gdAlertify.notiSuccess('Sesión Iniciada');
            })
            .catch(() => {
                setIsLoading(false);
                gdAlertify.notiError('Hubo un error en la solicitud');
            });
    };

    return (
        <div className='container d-flex justify-content-center align-items-center'>
            <div className="card mt-5">
                <div className="card-body">
                    <div className="login-container text-center">
                        <img src={Logo} alt="Logo Sk Medical" />
                        <h2>Ingresar</h2>
                        <form onSubmit={handleLogin}>
                            <div className="mb-3">
                                <label htmlFor="username" className="form-label">Usuario</label>
                                <input
                                    type="text"
                                    id="username"
                                    className="form-control"
                                    value={username}
                                    onChange={(e) => setUsername(e.target.value)}
                                />
                            </div>

                            <div className="mb-3">
                                <label htmlFor="password" className="form-label">Contraseña</label>
                                <div className="input-group">
                                    <input
                                        type={showPassword ? "text" : "password"} // 👈 alterna tipo
                                        id="password"
                                        className="form-control"
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                    />
                                    <button
                                        type="button"
                                        className="btn btn-outline-secondary"
                                        onClick={() => setShowPassword(!showPassword)}
                                    >
                                        <i className={showPassword ? "bi bi-eye-slash" : "bi bi-eye"}></i>
                                    </button>
                                </div>
                            </div>

                            <button type="submit" className="btn btn-primary w-100" disabled={isLoading}>
                                {isLoading ? 'Iniciando sesión...' : 'Iniciar Sesión'}
                            </button>
                        </form>

                        <button
                            type="button"
                            className="btn btn-link mt-2"
                            onClick={() => navigate("/recuperar-contrasena")}
                        >
                            Recuperar Contraseña
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Login;
